export type Tag = {
  id: number;
  name: string;
  category: TagCategory;
};

export type TagWithCount = Tag & {
  equipmentsCount: number;
  usersCount: number;
};

export type _TagWithCount = Tag & {
  _count: {
    equipments: number;
    users: number;
  };
};

export const TagCategory = {
  KIT: 'KIT',
  VEHICLE: 'VEHICLE',
  LOCATION: 'LOCATION',
  TYPE: 'TYPE',
  CUSTOMER: 'CUSTOMER',
  TEAM: 'TEAM',
  OTHER: 'OTHER',
} as const;

export type TagCategory = (typeof TagCategory)[keyof typeof TagCategory];
